import { MusicExploreCard } from "@/components/MusicExploreCard";
import { searchResultCountState } from "@/context/states";
import { useSearchPlaylists } from "@/lib/api";
import { Grid } from "@mui/material";
import { useEffect } from "react";
import { useRecoilState } from "recoil";

export default function PlaylistListPage({
  searchConfig,
  page = 0,
  limit = 24,
}) {
  const { playlists } = useSearchPlaylists(searchConfig, page, limit);

  const [searchResultCount, setSearchResultCount] = useRecoilState(
    searchResultCountState,
  );

  useEffect(() => {
    if (playlists) {
      setSearchResultCount({
        ...searchResultCount,
        playlists: page * limit + playlists.length,
      });
    }
  }, [playlists]);

  return (
    <>
      {playlists?.map((playlist) => (
        <Grid item xs={12} sm={6} key={playlist.id}>
          <MusicExploreCard variant="MusicExploreCard" playlist={playlist} />
        </Grid>
      ))}
    </>
  );
}
